import React from 'react';
import PropTypes from 'prop-types';

import TextLink from '../link/Textlink';

const LineTitleGray = (props) => {
  const { size, border, children, linkTitle, handleLinkClick } = props;
  return (
    <div className={`lineTitleGray ${border}`}>
      <div className={`lineTitle ${size}`}>
        {children}
      </div>
      {linkTitle && handleLinkClick && (
        <TextLink onClick={handleLinkClick}>{linkTitle}</TextLink>
      )}
    </div>
  );

};

LineTitleGray.defaultProps = {
  size: 'md', //sm, lg
  border: '', //border, borderAll
};

LineTitleGray.propTypes = {
  size: PropTypes.string,
  border: PropTypes.string,
  children: PropTypes.node,
  linkTitle: PropTypes.string,
  handleLinkClick: PropTypes.func,
};

export default LineTitleGray;
